/*! Copyright (c) Safe As Milk. All rights reserved. */
class PortraitVideo extends HTMLElement {
  static currentlyPlaying = null;

  connectedCallback() {
    this.playButton = this.querySelector("[data-portrait-video-play]");
    if (!this.playButton) return;

    this.playButton.addEventListener("click", this.#onPlayClick.bind(this));
  }

  #onPlayClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (
      PortraitVideo.currentlyPlaying &&
      PortraitVideo.currentlyPlaying !== this
    ) {
      PortraitVideo.currentlyPlaying.#stop();
    }

    if (!this.hasAttribute("loaded")) {
      this.#loadContent();
    }

    const video = this.querySelector("video");
    if (!video) return;

    video
      .play()
      .then(() => {
        this.classList.add("is-playing");
        PortraitVideo.currentlyPlaying = this;
      })
      .catch(() => {});
  }

  #loadContent() {
    const template = this.querySelector("template");
    if (!template) return;

    this.setAttribute("loaded", true);
    const video = template.content.firstElementChild.cloneNode(true);
    this.appendChild(video);

    video.addEventListener("ended", () => {
      if (!video.loop) this.#stop();
    });
  }

  #stop() {
    const video = this.querySelector("video");
    if (video) video.pause();

    this.classList.remove("is-playing");

    if (PortraitVideo.currentlyPlaying === this) {
      PortraitVideo.currentlyPlaying = null;
    }
  }
}

customElements.define("portrait-video", PortraitVideo);

export default PortraitVideo;
